import { render, staticRenderFns } from "./JobPrePublishedJob.vue?vue&type=template&id=220af0b0"
import script from "./JobPrePublishedJob.vue?vue&type=script&lang=js"
export * from "./JobPrePublishedJob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports